"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cacheGetEventData_1 = require("./cacheGetEventData");
var clearEventDataCache_1 = require("./clearEventDataCache");
var CONTENTSEARCHER_KEY = 'CONTENTSEARCHER';
/**
 * Try get existing PositionContentSearcher from an event. If there isn't one, create a new one from editor.
 * @param event The plugin event, it stores the event cached data for looking up.
 * If passed as null, we will create a new PositionContentSearcher
 * @param editor The editor instance
 * @returns The PositionContentSearcher object
 */
function cacheGetContentSearcher(event, editor) {
    return cacheGetEventData_1.default(event, CONTENTSEARCHER_KEY, function () { return editor.getContentSearcherOfCursor(); });
}
exports.cacheGetContentSearcher = cacheGetContentSearcher;
/**
 * Clear the PositionContentSearcher in a plugin event.
 * This is called when the content is changed
 * @param event The plugin event
 */
function clearContentSearcherCache(event) {
    clearEventDataCache_1.default(event, CONTENTSEARCHER_KEY);
}
exports.clearContentSearcherCache = clearContentSearcherCache;
//# sourceMappingURL=cacheGetContentSearcher.js.map